module.exports = __webpack_public_path__ + "static/media/button-zahngold.6aba71ee.svg";